import * as React from 'react';
import config from '../../../config';
import { GoogleMap, GoogleMapProps, useJsApiLoader } from '@react-google-maps/api';
import { Spinner } from '@blueprintjs/core';

const zoomSteps: boolean = false;

export interface PharmagardeMapProps extends GoogleMapProps {
  children?: JSX.Element[] | JSX.Element;
  gridSize?: number;
  zoomStep?: number;
  initialZoom?: number; //watch out for fitbounds methods that also play with the zoom
  maximalZoom?: number;
  minimalZoom?: number;
  fullscreenControl?: boolean;
}

type Libraries = ('drawing' | 'geometry' | 'localContext' | 'places' | 'visualization')[];
const libraries: Libraries = ['drawing'];

const PharmagardeMap = (props: PharmagardeMapProps) => {
  const { isLoaded } = useJsApiLoader({
    googleMapsApiKey: config.googleMapApiKey,
    libraries: libraries,
  });

  var propsCopy = {};
  for (const propKey in props) {
    propsCopy[propKey] = props[propKey];
  }
  if (props.initialZoom) {
    propsCopy['defaultZoom'] = props.initialZoom;
    //the line above should be enough but just in case (and to prevent interferences):
    propsCopy['options']['defaultZoom'] = props.initialZoom;
    propsCopy['options']['zoom'] = props.initialZoom;
    propsCopy['zoom'] = props.initialZoom;
  }
  if (props.maximalZoom) {
    propsCopy['options']['maxZoom'] = props.maximalZoom;
    //the line above should be enough but just in case (and to prevent interferences):
    propsCopy['maxZoom'] = props.maximalZoom;
  }
  if (props.minimalZoom) {
    propsCopy['options']['minZoom'] = props.minimalZoom;
    //the line above should be enough but just in case (and to prevent interferences):
    propsCopy['minZoom'] = props.minimalZoom;
  }

  //useWhatChanged(props as { [prop: string]: unknown });

  return isLoaded ? (
    <GoogleMap {...propsCopy} zoom={props.zoom || 9}>
      {props.children}
    </GoogleMap>
  ) : (
    <Spinner />
  );
};

const defaultProps = {
  mapContainerStyle: { height: `100%`, width: '100%' },
  options: {
    gestureHandling: 'cooperative',
    scaleControl: true,
    minZoom: 10,
    maxZoom: 17,
    scrollwheel: !zoomSteps,
    fullscreenControl: true,
  }, //zoom between 0-18
  gridSize: 20,
  fullscreenControl: true,
} as Partial<PharmagardeMapProps>;

export default (props: PharmagardeMapProps) => (
  <PharmagardeMap {...defaultProps} {...props} center={props.center || defaultProps.center}>
    {props.children}
  </PharmagardeMap>
);
